// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3wdUG","content":"ManualTimeModal_content__kN1d7"};